import React from "react";
import { Result, Button } from "antd";
import { Link } from "react-router-dom";

const Unauthorized = ({
  message = "You don't have permission to access this page",
}) => {
  return (
    <Result
      status="403"
      title="Unauthorized"
      subTitle={message}
      extra={
        <Link to="/dashboard">
          <Button type="primary">Back to Dashboard</Button>
        </Link>
      }
    />
  );
};

export default Unauthorized;
